class VgTable {
	constructor(gymId, tableContainer, withCTA = false) {
		this.center = gymId,
		this.cta = withCTA,
		this.tableContainer = tableContainer,
		this.vgApiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
		this.init();
	}

	async init() {
		const subscriptionsData = await this.vgApiClient.getSubscriptions(this.center, VgHelpers.getCountry());

		if (!subscriptionsData || subscriptionsData?.error) {
			console.error("Error getting subscriptions data");
			const container = document.querySelector(".vg-compare-table__container");
			container.innerHTML = '';
			return;
		} else {
			this.renderComparisionTable(gymId, this.tableContainer, subscriptionsData);
			if (this.cta) {
				this.renderCTA(subscriptionsData);
				this.priceToogle();
				this.addSwitchEvents();
			}
		}
	}

	async renderComparisionTable(gymId, tableContainer, subscriptionsData) {
		const tableParentElement = document.querySelector('.vg-compare-table__content');
		const isOneFlexOrPrime = this.isOneFlexOrPrimeSubscription(subscriptionsData);
		const availableGymsForZone = await this.vgApiClient.getSubscriptionsGymsByRegion(gymId);

		const tableHead = document.createElement("thead");
		const tableRow = document.createElement("tr");
		const tableCol = document.createElement("th");
		tableRow.appendChild(tableCol);

		tableContainer.classList.add("vg-table--col-" + this.countSubscriptions(subscriptionsData));
		tableContainer.appendChild(tableHead);

		subscriptionsData.subscriptions?.forEach((subscription) => {
			if (!vgHelpersData.global_ids.dayPassGlobalId.includes(subscription.product.globalId)) {

				// TODO: when webParking is available, use it instead name
				let subscriptionName = subscription.product.webname;
				subscriptionName = subscriptionName.replace("Cuota ", "").toLowerCase();

				const isMostPopular = subscription.product.mostPopular;
				const tableCol = document.createElement("th");
				tableCol.innerHTML =
				`
					<div class="${isMostPopular ? 'quote-featured' : ''}">
						<span>${subscriptionName.toUpperCase()}</span>
					</div>
				`;
				tableRow.appendChild(tableCol);
			}
		});

		tableHead.appendChild(tableRow);

		const tableBody = document.createElement("tbody");

		tableReference.forEach((row, index) => {

			const tableRow = document.createElement("tr");
			tableRow.classList.add("vg-table__item");
			tableRow.classList.add("border-line-top");
			const rowCol = document.createElement("td");
			rowCol.classList.add("vg-select-quote__quote-label");
			rowCol.classList.add("vg-table__cell-label");
			rowCol.innerHTML = row.label;

			if (isOneFlexOrPrime && row.label_2) {
				rowCol.innerHTML = row.label_2;
			}

			if (row['tooltip']) {

				let toolTipText = '';

				if (availableGymsForZone.error === null && !isOneFlexOrPrime) {
					if (availableGymsForZone.accessToAllGyms) {
						toolTipText = row['tooltip_1'];
					} else {
						toolTipText = row['tooltip_2'] + this.formatGymsByZone(availableGymsForZone.regions);
					}
				}

				if (isOneFlexOrPrime) {
					toolTipText = row['tooltip_3'];
				}

				rowCol.innerHTML +=
				`
				<vg-tooltip>
					<i class="icon icon--help-question vg-tooltip__trigger"></i>
					<div class="vg-tooltip__panel">${toolTipText}</div>
				</vg-tooltip>
				`;
			}

			tableRow.appendChild(rowCol);

			subscriptionsData.subscriptions?.forEach((subscription) => {
				if (!vgHelpersData.global_ids.dayPassGlobalId.includes(subscription.product.globalId)) {

					const isMostPopular = subscription.product.mostPopular;
					const tableCol = document.createElement("td");
					tableCol.classList.add("vg-table__cell");

					if (isMostPopular) {
						tableCol.classList.add("quote-featured");
					}

					// TODO: when webParking is available, use it instead name
					let subscriptionName = subscription.product.webname;

					// TODO: general data should don't have this replace and not depend on the name (zone - club - iberia)!
					subscriptionName = subscriptionName.replace("Cuota ", "").toLowerCase();
					subscriptionName = subscriptionName.replace("corporate ", "");

					if (row[subscriptionName] === true) {
						tableCol.innerHTML = `<i class="icon icon--check"></i>`;
					} else {
						tableCol.innerHTML = row[subscriptionName] ?? "";

						if (row['key'] === 'gym-count') {
							tableCol.innerHTML = subscription.availableGyms;

							if (vgHelpersData.global_ids.subOneId.includes(subscription.product.globalId)) {
								tableCol.innerHTML = '';
							}
							if (vgHelpersData.global_ids.subFlexId.includes(subscription.product.globalId)) {
								tableCol.innerHTML = subscription.WEBGymIsNotInAGroupForFlex && subscription.WEBGymIsNotInAGroupForFlex == true ? `<i class="icon icon--check"></i>` : '';
							}
							if (vgHelpersData.global_ids.subPrimeId.includes(subscription.product.globalId)) {
								tableCol.innerHTML = `<i class="icon icon--check"></i>`;
							}
						}

						if (row['key'] === 'water-price') {
							let addons = subscription.availableAddOnProducts;
							if (addons) {
								addons.forEach((addon) => {
									if (vgHelpersData.global_ids.waterGlobalId.includes(addon.productGroupName)) {
										rowCol.innerHTML = rowCol.innerHTML.replace("[WATER]", addon.webname);
										tableCol.innerHTML = this.priceFormat(addon.normalPeriodPrice);
									}
								});
							}
						}

						if (row['key'] === 'parking') {
							if (subscription.parking) {
								tableCol.innerHTML = `<i class="icon icon--check"></i>`;

							}
						}

						if (row['key'] === 'baf') {
							if (subscription.BAF) {
								tableCol.innerHTML = `<i class="icon icon--check"></i>`;

							}
						}
					}
					tableRow.appendChild(tableCol);
				}
			});

			tableBody.appendChild(tableRow);
			
			if (row['key'] === 'water-price' && !this.subscriptionsHasWaterAddon(subscriptionsData)) {
				tableRow.remove();
			} else {
				tableBody.appendChild(tableRow);
			}


		});
		tableContainer.appendChild(tableBody);
		tableParentElement.classList.toggle("is-loading");
	}

	isOneFlexOrPrimeSubscription(subscriptionsData) {
		let hasOneFlexOrPrime = false;
		subscriptionsData.subscriptions.forEach((subscription) => {
			if (vgHelpersData.global_ids.subOneFlexPrimeId.includes(subscription.product.globalId)) {
				hasOneFlexOrPrime = true;
			}
		});
		return hasOneFlexOrPrime;
	}

	getFeaturedSubscription(subscriptionsData) {
		let featured = null;
		subscriptionsData.forEach((subscription) => {
			if (subscription.product.mostPopular) {
				featured = subscription;
			}
		});
		return featured;
	}

	getSubscriptionByGlobalId(globalId, subscriptionsData) {
		let subscription = null;
		subscriptionsData.subscriptions.forEach((sub) => {
			if (sub.product.globalId === globalId) {
				subscription = sub;
			}
		});
		return subscription;
	}

	formatGymsByZone(gymList) {

		let gymListFormatted = "<ul>";

		Object.entries(gymList).forEach(([region, gyms]) => {
			let regionElement = '<li>';
			regionElement += `<strong>${region}:</strong> `;
			gyms.forEach(gym => {
				regionElement += `${gym}, `;
			});
			regionElement = regionElement.slice(0, -2);
			regionElement += '</li>';

			gymListFormatted += regionElement;

		});

		gymListFormatted += "</ul>";

		return gymListFormatted;
	}

	subscriptionsHasWaterAddon(subscriptionsData) {
		let hasWaterAddon = false;
		subscriptionsData.subscriptions.forEach((subscription) => {
			if (subscription.availableAddOnProducts) {
				subscription.availableAddOnProducts.forEach((addon) => {
					if (vgHelpersData.global_ids.waterGlobalId.includes(addon.productGroupName)) {
						hasWaterAddon = true;
					}
				});
			}
		});

		return hasWaterAddon;
	}

	countSubscriptions(subscriptionsData) {
		let count = 0;
		subscriptionsData.subscriptions.forEach((subscription) => {
			if (!vgHelpersData.global_ids.dayPassGlobalId.includes(subscription.product.globalId)) {
				count++;
			}
		});

		return count;
	}

	renderCTA(subscriptionsData) {

		const featuredSubscription = this.getFeaturedSubscription(subscriptionsData.subscriptions);

		if (featuredSubscription) {
			this.updateRegistrationPrice(featuredSubscription);
			this.updatePromotionBanner(featuredSubscription);
		}

		subscriptionsData.subscriptions.forEach((subscription) => {
			if (vgHelpersData.global_ids.dayPassGlobalId.includes(subscription.product.globalId)) {
				this.renderDayPassCTA(subscription);
				return;
			}
			const subscriptionContainer = document.querySelector(".vg-compare-table__quotes-list");
			subscriptionContainer.classList.add("vg-compare-table__quotes-list--col-" + this.countSubscriptions(subscriptionsData));

			this.renderSubscriptionCTA(subscription);
		});
	}

	renderSubscriptionCTA(subscription) {
		const subscriptionParent = document.querySelector(".vg-compare-table__quotes");
		const subscriptionContainer = subscriptionParent.querySelector(".vg-compare-table__quotes-list");
		let subscriptionName = subscription.product.webname;
		subscriptionName = subscriptionName.replace("Cuota ", "").toLowerCase();
		const isMostPopular = subscription.product.mostPopular;


		const subscriptionUrl = '/' + VgHelpers.getCountry() + '-' + VgHelpers.getLanguage() + '/joining-2/?gym=' + this.center + '&sub=' + subscription.product.globalId;
		const subscriptionPrice = this.priceFormat(subscription.periodPrice);

		const template = document.querySelector("#quotes-element");
		const clone = template.content.cloneNode(true);

		const globalIdElement = clone.querySelector("[data-global-id]");
		globalIdElement.setAttribute("data-global-id", subscription.product.globalId);

		const link = clone.querySelectorAll("a");
		link[0].href = subscriptionUrl;
		link[0].innerHTML = `<span data-slot-text class="vg-product__cta">${link[0].querySelector("[data-slot-text]").innerHTML}</span><span data-slot-price class="vg-product__price has-h-3-font-size" data-price="${subscriptionPrice}">${subscriptionPrice}€</span>`;
		const isMostPopularClass ='ob-button--' + (isMostPopular ? 'primary' : 'secondary');
		link[0].classList.add(isMostPopularClass);

		const title = clone.querySelector(".vg-product__title");
		title.innerHTML = subscriptionName;

		subscriptionContainer.appendChild(clone);
	}

	renderDayPassCTA(subscription) {
		
		const dayPassContainer = document.querySelector(".vg-compare-table__quotes-special");
		const template = document.querySelector("#quotes-special-element");
		
		const clone = template.content.cloneNode(true);
		
		const link = clone.querySelectorAll("a");
		link[0].href = '/' + VgHelpers.getCountry() + '-' + VgHelpers.getLanguage() + '/joining-2/?gym=' + this.center + '&sub=' + subscription.product.globalId;
		const linkText = link[0].innerHTML;
		link[0].innerHTML = linkText.replace("[DAYPASS_LABEL]", subscription.product.webname);

		const price = clone.querySelectorAll(".quotes-special__price");
		let priceText = price[0].innerHTML;
		priceText = priceText.replace("[DAYPASS_PRICE]", this.priceFormat(subscription.periodPrice));
		price[0].innerHTML = priceText;

		dayPassContainer.appendChild(clone);
		dayPassContainer.classList.remove("is-loading");
	}

	initCTAListeners(subscriptionsData) {
		const subscriptionParent    = document.querySelector(".vg-compare-table__quotes");
		const subscriptionContainer = subscriptionParent.querySelector(".vg-compare-table__quotes-list");
		let selectedGlobalId        = null;
		
		subscriptionContainer.addEventListener("mouseover", (event) => {
			const selectedProduct = event.target.closest(".vg-product");
			const globalId = selectedProduct?.getAttribute("data-global-id");
			
			if (globalId === selectedGlobalId) return;
			
			selectedGlobalId = globalId;

			const subscription = this.getSubscriptionByGlobalId(globalId, subscriptionsData);

			this.updateRegistrationPrice(subscription);
			this.updatePromotionBanner(subscription);
		});
	}

	updateRegistrationPrice(subscription) {
		const registration              = document.querySelector(".vg-compare-table__quotes-registration");
		const registrationPrice         = registration?.querySelector("[data-slot]");
		const registrationPricePromoted = registration?.querySelector("[data-slot-promotion]");
		const registrationPriceEnd      = registration?.querySelector("[data-slot-end]");
		
		const isCreationPromoted  = subscription?.creationPrice != subscription?.creationNormalPrice ? true : false;
		const isCreationPriceZero = subscription?.creationPrice == "0.00" ? true : false;

		registrationPrice.innerHTML = this.priceFormat(subscription?.creationNormalPrice) + "€";

		if (isCreationPromoted) {
			registrationPrice.classList.add("price-underline");
		} else {
			registrationPrice.classList.remove("price-underline");
		}

		if (isCreationPriceZero) {
			registrationPriceEnd.classList.remove("disabled");
		} else {
			registrationPriceEnd.classList.add("disabled");
		}

		if (isCreationPromoted && !isCreationPriceZero) {
			registrationPricePromoted.innerHTML = subscription.creationPrice + "€";
		} else {
			registrationPricePromoted.innerHTML = "";
		}
	}

	updatePromotionBanner(subscription) {
		const promotionBanner = document.querySelector(".vg-compare-table__quotes-promotion");
		const promotionText   = promotionBanner.querySelector("[data-slot]");

		const isCreationPromoted = subscription?.creationPrice != subscription?.creationNormalPrice ? true : false;

		if (isCreationPromoted) {
			promotionBanner.classList.remove("disabled");
			promotionText.innerHTML = subscription.creationPriceText;
			
		} else {
			promotionBanner.classList.add("disabled");
		}
	}

	priceToogle() {
		const toggleWeekly = document.getElementById("vg-select-quote--weekly");
		const toggleMonthly = document.getElementById("vg-select-quote--monthly");

		toggleWeekly?.addEventListener("change", () => {
			this.switchWeeklyPrice();
		});

		toggleMonthly?.addEventListener("change", () => {
			this.switchMonthlyPrice();
		});
	}

	switchWeeklyPrice() {
		document.querySelectorAll("[data-slot-price]").forEach((price) => {
			const priceValue = price.getAttribute("data-price");
			price.innerHTML = this.monthlyToWeeklyPrice(priceValue) + "€";
		});
	}

	switchMonthlyPrice() {
		document.querySelectorAll("[data-slot-price]").forEach((price) => {
			const priceValue = price.getAttribute("data-price");
			price.innerHTML = this.priceFormat(priceValue) + "€";
		});
	}

	addSwitchEvents() {
		let currentlyChecked = null;
		const radios = document.querySelectorAll('[name="vg-select-quote--montly"]');

		radios.forEach( (r) => {
			if (r.checked) {
				currentlyChecked = r;
			}

			r.addEventListener("click", (e) => {
				// Skip if click comes from the label.
				if (e.explicitOriginalTarget !== e.originalTarget) return;
				if (currentlyChecked === e.target) {
					radios.forEach((ri) => {
						if (ri === e.target) {
							ri.checked = false;
						} else {
							ri.checked = true;
							currentlyChecked = ri;
							const trigger = new Event('change');
							ri.dispatchEvent(trigger);
						}
					})
					return;
				}
				currentlyChecked = e.target;
			});
		});
	}

	monthlyToWeeklyPrice(price) {
		let weeklyPrice = (parseFloat(price) * 12) / 52;
		let roundedPrice = weeklyPrice.toFixed(2);
		return roundedPrice.replace(".", ",");
	}

	priceFormat(price) {
		if (typeof price === "number" || !isNaN(price)) {
			price = parseFloat(price).toFixed(2);
		}

		if (typeof price !== "string") {
			price = price.toString();
		}

		return price.replace(".", ",");
	}

}